import { breakpoints, media } from './Media'

export const theme = {
  colors: {
    brand: {
      black: '#0E0E0E',
      blue: '#184167',
      yellow: '#D8B54A'
    },
    success: '#09C549',
    lightPrimary: '#8490d9',
    textColors: {
      titles: '#9BABC5'
    },

    danger: '#EE2727',
    darkGrey: '#242323',
    grey: '#BFC7D0',
    blue: '#5395FF'
  },
  media,
  breakpoints
}
